export enum StatusEnum {
  success = 'success',
  error = 'error',
}
